/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */


import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Helpers} from './helpers';

@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit, AfterViewInit {
  title = 'app';

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    Helpers.setLoading(false);
  }

  ngAfterViewInit() {
    // This is intentional
  }

}
